import { useEffect, useRef, useState } from "react";

export default function LazyVideo({ cloudinarySrc, poster, className, delay = 0 }) {
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setShouldLoad(true);
      }, delay);
    };

    // Check if page is already loaded
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, [delay]);

  useEffect(() => {
    if (shouldLoad && videoRef.current && cloudinarySrc) {
      videoRef.current.src = cloudinarySrc;
      videoRef.current.load();
    }
  }, [shouldLoad, cloudinarySrc]);

  return (
    <video
      ref={videoRef}
      autoPlay
      loop
      muted
      playsInline
      preload="none"
      poster={poster}
      className={`${className} ${isLoaded ? "fade-in" : ""}`}
      onLoadedData={() => setIsLoaded(true)}
    />
  );
}
